import { useProProfile } from "api/queries/pros";
import { HireFeeActionButtons } from "domains/hire/components/HireFee/HireFeeActionButtons";
import { HireFeeWidgetDetailed } from "domains/hire/components/HireFee/HireFeeWidgetDetailed";
import { SendHireOfferDialogContainer } from "domains/hire/containers/SendHireOfferDialog";
import { useHasJobsAccess } from "domains/hire/hooks/useHasJobsAccess";
import React from "react";

interface HireFeeProfileSectionProps {
  proId: number;
}

export const HireFeeProfileSection: React.FC<HireFeeProfileSectionProps> = ({ proId }) => {
  const hasJobsEnabled = useHasJobsAccess();
  const { data } = useProProfile(proId);
  const [inviteDialogOpen, setInviteDialogOpen] = React.useState(false);

  if (!hasJobsEnabled || !data?.hire_fee_data) return null;

  const spaceIndex = data.display_name?.indexOf(" ") ?? -1;
  const firstName = (spaceIndex === -1 ? data.display_name : data.display_name?.slice(0, spaceIndex)) ?? "Pro";

  return (
    <div className="w-full shrink-0 @3xl/profile:w-72">
      <HireFeeWidgetDetailed hireFee={data.hire_fee_data} proFirstName={firstName} />
      <HireFeeActionButtons
        onHireNow={() => setInviteDialogOpen(true)}
        pricing={data.hire_fee_data.pricing}
        proFirstName={firstName}
        variant="detailed"
        className="mt-2"
      />
      <SendHireOfferDialogContainer open={inviteDialogOpen} onClose={() => setInviteDialogOpen(false)} proId={proId} />
    </div>
  );
};
